import React from 'react';
export function Hero() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  const benefitsDesktop = ['Alternativas prácticas al gluten', 'Recetas paso a paso', 'Acceso inmediato'];
  const benefitsMobile = ['Alternativas prácticas', 'Recetas paso a paso', 'Acceso inmediato'];
  const steps = ['APRENDE', 'SUSTITUYE', 'RECREA'];
  return <div className="w-full max-w-full overflow-x-hidden" data-id="element-82" data-mp="xb5szim1qzxu">
      {/* MOBILE — designed specifically for small viewports, not a compressed desktop */}
      <div className="md:hidden w-full max-w-full pt-5 pb-1" data-id="element-83" data-mp="ncq0bb7dfim8">
        <div className="text-center px-4 max-w-full" data-id="element-84" data-mp="neav91xll3km">
          <div className="inline-flex items-center gap-1.5 bg-white border border-brand-border rounded-full px-3 py-1 text-brand-primary font-semibold text-[10px] tracking-[0.12em] uppercase mb-3 shadow-sm" data-id="element-85" data-mp="3d2labedjz91r">
            Sistema práctico · 100% digital
          </div>

          <h1 className="font-display text-brand-title font-bold tracking-tight mb-2 text-[27px] leading-[1.2] max-w-full" data-id="element-86" data-mp="3o7c1q2dl4xiq">
            Come como siempre.{' '}
            <span className="text-brand-secondary" data-id="element-87" data-mp="39a37n0wwdfnb">
              Sin depender del gluten.
            </span>
          </h1>

          <p className="text-[14px] text-brand-text mb-3 leading-snug font-body max-w-[300px] mx-auto" data-id="element-88" data-mp="30i18d5yke5em">
            Aprende a recrear panes, masas, pastas y tus platos favoritos
            utilizando alternativas al gluten.
          </p>

          <div className="grid grid-cols-3 gap-1.5 mb-3.5 max-w-full" data-id="element-89" data-mp="2qkwjuzh8xxun">
            {benefitsMobile.map((b, i) => <div key={i} className="flex flex-col items-center justify-center gap-1 bg-white/60 border border-brand-border/50 rounded-lg px-1 py-1.5 min-h-[44px]" data-id="element-90" data-mp="2vjzoiitbe223" data-mpi={i}>
                <span className="text-brand-primary font-bold text-[11px] leading-none" data-id="element-91" data-mp="2lkimqch6o8be">
                  ✓
                </span>
                <span className="text-[10px] text-brand-textMuted font-body leading-tight text-center" data-id="element-92" data-mp="s333va8e4ivy">
                  {b}
                </span>
              </div>)}
          </div>

          <button onClick={scrollToPricing} className="bg-brand-primary hover:bg-brand-primaryHover text-white font-heading font-bold text-base py-3.5 rounded-xl transition-colors w-full shadow-card-lg" data-id="element-93" data-mp="ibgm0v1jrlk8">
            Quiero descubrir el sistema
          </button>

          <div className="text-brand-textMuted font-medium text-xs tracking-wide mt-2 mb-0" data-id="element-94" data-mp="1ayjgnc33rc57">
            Acceso inmediato · Material digital
          </div>
        </div>

        <div className="w-full flex justify-center -mt-1 px-4 max-w-full" data-id="element-95" data-mp="11151rgwtuvf0">
          <div className="relative w-[92%] max-w-[380px] aspect-square" data-id="element-96" data-mp="x031cwr6cdbg">
            <img src="https://cdn.magicpatterns.com/uploads/1gwhDJbWYAzPqP47WvppdA/ChatGPT_Image_9_ago_2026__14_24_27-removebg-preview.png" alt="Sistema Mimetismo Nutricional™ — 6 Tomos + 6 Bonos Exclusivos" width="800" height="800" fetchPriority="high" loading="eager" decoding="sync" className="w-full h-full object-contain" data-id="element-97" data-mp="3lsoyt0hf3v83" />
          </div>
        </div>
      </div>

      {/* DESKTOP — two-column composition */}
      <div className="hidden md:block w-full max-w-full pt-10 pb-12 px-4" data-id="element-98" data-mp="269r2hsmsnc8z">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center" data-id="element-99" data-mp="2b0fwpfpuynbt">
          {/* Left column — copy */}
          <div className="text-left" data-id="element-100" data-mp="2g0lr33niinxl">
            <div className="inline-flex items-center gap-2 bg-white border border-brand-border rounded-full px-4 py-1.5 text-brand-primary font-semibold text-xs tracking-[0.15em] uppercase mb-6 shadow-sm" data-id="element-101" data-mp="2fzj4h7x837nh">
              Sistema práctico · 100% digital
            </div>

            <h1 className="font-display text-brand-title font-bold tracking-tight mb-5 text-5xl lg:text-[52px] leading-[1.12]" data-id="element-102" data-mp="2tyino01yuuc9">
              Come como siempre.{' '}
              <span className="text-brand-secondary" data-id="element-103" data-mp="zlaoxxavdylc">
                Sin depender del gluten.
              </span>
            </h1>

            <p className="text-lg text-brand-text mb-6 leading-relaxed max-w-xl font-body" data-id="element-104" data-mp="4a2ulkgef9zm">
              Descubre el Sistema Mimetismo Nutricional™ y aprende a
              reconstruir panes, masas, pastas y tus platos favoritos
              utilizando alternativas al gluten, sin resignarte a comer
              diferente.
            </p>

            <div className="flex flex-wrap items-center gap-x-5 gap-y-2 mb-8 text-sm text-brand-text font-body" data-id="element-105" data-mp="98mkfvy455x9">
              {benefitsDesktop.map((b, i) => <span key={i} className="inline-flex items-center gap-1.5 whitespace-nowrap" data-id="element-106" data-mp="3cs8ri80uanrm" data-mpi={i}>
                  <span className="text-brand-primary font-bold" data-id="element-107" data-mp="3rgc0zre3chl6">✓</span>
                  {b}
                </span>)}
            </div>

            <button onClick={scrollToPricing} className="bg-brand-primary hover:bg-brand-primaryHover text-white font-heading font-bold text-xl py-4 px-10 rounded-xl transition-colors w-auto shadow-card-lg" data-id="element-108" data-mp="3mo2dsj4d1vml">
              Quiero descubrir el sistema
            </button>

            <div className="text-brand-textMuted font-medium text-sm tracking-wide mt-4" data-id="element-109" data-mp="19hm6dtslrygb">
              Acceso inmediato · Material digital · Empieza hoy
            </div>
          </div>

          {/* Right column — mockup with subtle gastronomic collage */}
          <div className="relative flex justify-end" data-id="element-110" data-mp="14jkgoq0o90vv">
            <div className="relative w-full max-w-lg aspect-square" data-id="element-111" data-mp="14k3v3wr45755">
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/e5fc5124-93ef-444b-a413-4c5df04d17c9.jpg" alt="" aria-hidden="true" className="absolute -top-4 -left-6 w-36 h-36 rounded-full object-cover opacity-30 blur-[1px] grayscale-[15%] -z-10" data-id="element-112" data-mp="1s8vjse5hv7d6" />
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/7ad5ad3d-7c30-45b6-974b-34f44ab275b1.jpg" alt="" aria-hidden="true" className="absolute top-2 -right-8 w-32 h-32 rounded-full object-cover opacity-25 blur-[1px] grayscale-[15%] -z-10" data-id="element-113" data-mp="1na24cg6nd6ad" />
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/2dc28840-75d6-4cc2-bdc0-2ed41966abc2.jpg" alt="" aria-hidden="true" className="absolute -bottom-6 -right-4 w-36 h-36 rounded-full object-cover opacity-25 blur-[1px] grayscale-[15%] -z-10" data-id="element-114" data-mp="bwgcuodbeslo" />
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/e0ee02ce-49ea-49ff-bbc5-eb9cd79067b8.jpg" alt="" aria-hidden="true" className="absolute bottom-0 -left-8 w-28 h-28 rounded-full object-cover opacity-25 blur-[1px] grayscale-[15%] -z-10" data-id="element-115" data-mp="24qphb8fz9zab" />

              <img src="https://cdn.magicpatterns.com/uploads/1gwhDJbWYAzPqP47WvppdA/ChatGPT_Image_9_ago_2026__14_24_27-removebg-preview.png" alt="Sistema Mimetismo Nutricional™ — 6 Tomos + 6 Bonos Exclusivos" width="800" height="800" fetchPriority="high" loading="eager" decoding="sync" className="relative z-10 w-full h-full object-contain drop-shadow-xl" data-id="element-116" data-mp="1qs9brktuqetr" />

              <div className="absolute bottom-6 left-4 z-20 bg-brand-primary text-white text-sm font-heading font-bold tracking-wide px-4 py-2 rounded-full shadow-card whitespace-nowrap" data-id="element-117" data-mp="3g64ot65tc9jo">
                6 Tomos + Bonos
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Trust strip */}
      <div className="max-w-3xl w-full mx-auto mt-1 md:mt-16 pt-3 md:pt-8 pb-5 md:pb-0 border-t border-brand-border text-center px-4" data-id="element-118" data-mp="3no2ka6r5tk3w">
        <p className="text-brand-textMuted text-xs md:text-sm font-body tracking-wide mb-2 md:mb-4" data-id="element-119" data-mp="1b401ykl7lur">
          Todo el sistema en un solo lugar
        </p>
        <div className="flex items-center justify-center gap-2 md:gap-6 text-brand-title font-heading font-bold text-xs md:text-base tracking-[0.08em] md:tracking-[0.1em] uppercase" data-id="element-120" data-mp="30sc2ovke66hd">
          {steps.map((step, i) => <React.Fragment key={i} data-id="element-121" data-mp="39t0dziiehsqk" data-mpi={i}>
              <span data-id="element-122" data-mp="3eq0ktvn2qziq">{step}</span>
              {i < steps.length - 1 && <span className="text-brand-secondary" data-id="element-123" data-mp="3ene7ffdi5psl">→</span>}
            </React.Fragment>)}
        </div>
      </div>
    </div>;
}